// API Configuration
// This file contains centralized API configuration that can be imported by all components

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

export const API_CONFIG = {
  headers: {
    'Authorization': 'Basic ' + btoa('Techland:Techland@24'),
    'Content-Type': 'application/json'
  }
};

// Alternative export for components that prefer destructuring
export const config = API_CONFIG;

// Helper function to get API URL with endpoint
export const getApiUrl = (endpoint) => {
  return `${API_BASE_URL}/${endpoint.replace(/^\//, '')}`; 
};

// Helper function to create axios config with additional options
export const createApiConfig = (additionalOptions = {}) => {
  return {
    ...API_CONFIG,
    ...additionalOptions
  };
};
